import { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";

const ForceHomeOnRefresh = () => {
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    const navType = performance.getEntriesByType("navigation")[0]?.type;

    // ✅ Check if user is admin on an admin route
    const token = localStorage.getItem("token");
    const role = localStorage.getItem("userRole");
    const isAdminUser = token && (role === "ADMIN" || role === "MANAGER");
    const isAdminRoute = location.pathname.startsWith("/admin");

    // ✅ Skip redirect for admin users on admin pages
    if (navType === "reload" && location.pathname !== "/" && !(isAdminUser && isAdminRoute)) {
      navigate("/", { replace: true });
    }
  }, []);

  return null;
};

export default ForceHomeOnRefresh;
